var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70427 10C8.16905 10 8.45274 9.74829 8.59158 9.27209 8.71229 8.78229 8.86925 8.53741 9.6962 8 10.5835 7.42175 11 6.72791 11 5.72791 11 4.07483 9.79881 3 7.96985 3 6.59965 3 5.59161 3.58502 5.18719 4.4422 5.06044 4.70068 5.00007 4.966 5.00007 5.25848 4.99403 5.87073 5.3562 6.26532 5.9236 6.26532 6.34613 6.26532 6.6902 6.04083 6.86523 5.59863 7.05237 5.10205 7.37831 4.85034 7.8612 4.85034 8.40446 4.85034 8.79681 5.2381 8.79681 5.78912 8.79681 6.37415 8.58554 6.66669 7.76463 7.21088 7.10669 7.63263 6.75055 8.12927 6.75055 8.87073 6.75055 9.4502 7.06622 10 7.70427 10zM7.79992 13C8.35019 13 8.79992 12.5599 8.79992 11.9972 8.79992 11.4401 8.35019 11 7.79992 11 7.24437 11 6.79992 11.4401 6.79992 11.9972 6.79992 12.5599 7.24437 13 7.79992 13z",
    fill: "currentColor"
  })));
}

export default SvgQuestion;